import Art from './Art'

// A numbered sequence with the apps' art. Used by both trunks' "how it works"
// pages, so the two sides of the marketplace are explained in the same shape.
//
// The number is the only ordinal: no connecting lines, no progress rail. A line
// drawn between four cards survives neither a narrow screen nor a reflow, and
// every version of it we have seen looks like a wizard.

export default function Steps({ steps }) {
  return (
    <ol className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
      {steps.map((s, i) => (
        <li key={s.title}>
          {s.art && <Art xml={s.art} className="h-[72px] w-[72px]" />}
          <p className="mt-4 text-[13px] font-semibold uppercase tracking-[0.12em] text-ink-muted">
            Step {i + 1}
          </p>
          <h3 className="mt-1.5 text-[21px] font-semibold">{s.title}</h3>
          <p className="mt-2 text-[17px] leading-relaxed text-ink-muted">{s.body}</p>
        </li>
      ))}
    </ol>
  )
}
